// extracted by mini-css-extract-plugin
export default {"switchModeDialogMessage":"SwitchModeDialogOpen_switchModeDialogMessage__14ySG","switchModeDialogList":"SwitchModeDialogOpen_switchModeDialogList__1ly_e"};